import { SettingMenuContext } from '@/contexts/SettingMenuContext';
import { getLocaleByCode } from '@/models/Locale';
import { LanguageIcon, VoiceIcon } from '@/modules/lobby/svg';
import { updateLocalStorageLanguage } from '@/utils/commonFunc';
import Grid from '@mui/material/Grid';
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { DialogContext } from '../..';
import { soundSliceActions } from '../../slice/sound';
import { LanguageSelector } from './LanguageSelector';
import { VoiceSelector } from './VoiceSelector';
import './index.scss';
const direction = 'column';
export const Language = () => {
    const dispatch = useDispatch();

    const { voiceSound, setVoiceSound, language, languageChangeHandler } =
        useContext(SettingMenuContext);
    const { t } = useTranslation();

    const { setExtraCloseHandler } = useContext(DialogContext);
    useEffect(() => {
        // set current value to the form
        setExtraCloseHandler(() => () => {});
    }, []);

    useEffect(() => {
        setExtraCloseHandler(() => () => {
            // update the local storage
            updateLocalStorageLanguage(getLocaleByCode('long', language).short);

            dispatch(
                soundSliceActions.updateAll({
                    // Music: musicSound,
                    Voice2: voiceSound,
                })
            );
        });
    }, [language, voiceSound]);

    const cn = ['language-setting-container', 'mx-auto'];
    return (
        <Grid container className={cn.join(' ')}>
            <Grid item className="language-setting-combo-box">
                <Grid
                    container
                    direction={direction}
                    className="language-setting-combo-box-container"
                >
                    <Grid item className="title">
                        <LanguageIcon></LanguageIcon>
                        {t('setting.display_language')}
                    </Grid>
                    <Grid item>
                        <LanguageSelector
                            language={language}
                            handleChangeLanguage={languageChangeHandler}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item className="language-setting-combo-box">
                <Grid
                    container
                    direction={direction}
                    className="language-setting-combo-box-container"
                >
                    <Grid item className="title">
                        <VoiceIcon></VoiceIcon>
                        {t('setting.voice_language')}
                    </Grid>
                    <Grid item>
                        <VoiceSelector
                            voiceSound={voiceSound}
                            setVoiceSound={setVoiceSound}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
